export const USER = `{
  id
  owner
  active_space_id
  createdAt
  updatedAt
}`
